import { useRelatedTasksForProduct } from "@coworker/apprestructured/src/tasks/hooks/useRelatedTasksForProduct";
import { nowAsISOWithOffsetInDays } from "../helpers/dates";
import {
  RELATED_TASKS_MAX_CLOSED,
  AVeryLargeDate,
} from "@coworker/consts/time";

const empty = [];

const DAY = 24 * 3600 * 1000;

function notClosedTooLongAgo(task) {
  const finishedAt = task.finished_at ?? task.closed_at;

  if (typeof finishedAt === "string") {
    return (
      !finishedAt ||
      finishedAt === AVeryLargeDate ||
      finishedAt > nowAsISOWithOffsetInDays(-RELATED_TASKS_MAX_CLOSED / DAY)
    );
  }

  return (
    !finishedAt ||
    finishedAt === Number.MAX_SAFE_INTEGER ||
    finishedAt > Date.now() - RELATED_TASKS_MAX_CLOSED
  );
}

export function useTasksForProduct(shortId) {
  const { data: relatedTasks, isLoading } = useRelatedTasksForProduct(
    shortId ?? ""
  );
  if (!isLoading) {
    const hasVersionedLists =
      Array.isArray(relatedTasks?.v1Tasks) &&
      Array.isArray(relatedTasks?.v2Tasks);
    const sourceV1Tasks = hasVersionedLists
      ? relatedTasks.v1Tasks
      : relatedTasks?.list || [];
    const sourceV2Tasks = hasVersionedLists ? relatedTasks.v2Tasks : [];

    const shouldIncludeTask = (task) => {
      if (task.task_type === "PRODUCT_QUALITY") return false;
      if (task.state === "COMPLETED" || task.state === "completed") {
        return false;
      }
      if (task.state === "CLOSED" || task.state === "closed") {
        if (!notClosedTooLongAgo(task)) return false;
      }
      return true;
    };

    const v1Tasks = sourceV1Tasks.filter(shouldIncludeTask);
    const v2Tasks = sourceV2Tasks.filter(shouldIncludeTask);
    const chosen = [...v1Tasks, ...v2Tasks];
    const ofWhichClosed = chosen.filter(
      ({ state }) => state === "CLOSED" || state === "closed"
    ).length;

    return {
      list: chosen.length ? chosen : empty,
      formattedCount: chosen.length,
      ofWhichClosed,
      loading: false,
      ...(hasVersionedLists && { v1Tasks, v2Tasks }),
    };
  } else {
    return {
      list: empty,
      formattedCount: 0,
      ofWhichClosed: 0,
      loading: isLoading,
    };
  }
}
